import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { Location } from '@angular/common';
import{ Router } from '@angular/router';

@Component({
  selector: 'app-final-approval-data',
  templateUrl: './final-approval-data.component.html',
  styleUrls: ['./final-approval-data.component.scss']
})
export class FinalApprovalDataComponent implements OnInit {

  constructor(public router:Router,public location:Location,public appservice:AppService) { }
approveEmployee(data){
  
  this.appservice.Editfinalapproverdata.employeecode=data;
  this.appservice.Editfinalapproverdata.status="Approved";
  this.appservice.Editfinalapproverdata.employeecode=data;
  console.log('the empcode is',data)
  this.appservice.FinalApproverdata.employeecode=data;
  this.appservice.Editfinalapproverdata.createdby=this.appservice.username;
  this.appservice.editfinalapprover="approved"
  this.router.navigate(['/home/finalapprover'])
}
rejectEmployee(data){
  
  this.appservice.Editfinalapproverdata.employeecode=data;
  this.appservice.Editfinalapproverdata.status="Rejected";
  this.appservice.Editfinalapproverdata.employeecode=data;
    this.appservice.FinalApproverdata.employeecode=data;

  this.appservice.Editfinalapproverdata.createdby=this.appservice.username;
  this.appservice.editfinalapprover="rejected"
  this.router.navigate(['/home/finalapprover'])
}
  ngOnInit(): void {
    this.appservice.FinalApproverdatafetch()
  }


}
